import React, { useEffect, useState } from "react";
import Popup from "~/assets/js/components/Popup";
import PropTypes from "prop-types";
import ExtraIngredients from "../Ingredients/ExtraIngredients";
import OverviewIngredients from "../Ingredients/OverviewIngredients";

export const VIEWS = {
    EXTRA: "extra",
    OVERVIEW: "overview",
};

const DesktopConfiguratorOverlay = ({
    open,
    handleClose,
    initialView,
    discounted,
}) => {
    const [currentView, setCurrentView] = useState(initialView);

    useEffect(() => {
        setCurrentView(initialView);
    }, [initialView]);

    const popupConfig = {
        customStyle: "desktop-configurator-overlay",
        handleClose: handleClose,
        open: open,
    };

    const renderView = () => {
        switch (currentView) {
            case VIEWS.OVERVIEW:
                return (
                    <OverviewIngredients
                        discounted={discounted}
                        handleClickBack={handleClose}
                        handleClose={handleClose}
                    />
                );
            case VIEWS.EXTRA:
            default:
                return (
                    <ExtraIngredients
                        discounted={discounted}
                        handleClose={handleClose}
                        onClickForward={() => setCurrentView(VIEWS.OVERVIEW)}
                    />
                );
        }
    };

    return <Popup {...popupConfig}>{renderView()}</Popup>;
};

export default DesktopConfiguratorOverlay;

DesktopConfiguratorOverlay.propTypes = {
    open: PropTypes.bool,
    discounted: PropTypes.bool,
    handleClose: PropTypes.func,
    initialView: PropTypes.oneOf([VIEWS.EXTRA, VIEWS.OVERVIEW]),
};
